module.exports = __webpack_public_path__ + "static/media/everly.5133302e.jpg";